import CryptoJS from 'crypto-js';
import { AWS_REGION, AWS_SECRET_KEY_ID, AWS_SECRET_ACCESS_KEY, CRYPTO_ACCESS_KEY, APP_FLOW } from '../common/constant';
import AWS from 'aws-sdk';
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { config, paths, charityConfig } from '../common/constant';
import { CARD_AMERICAN, CARD_DEFAULT, CARD_DINERS_CLUB, CARD_JCB, CARD_MASTER_CARD, CARD_UNION_PAY, CARD_VISA, CARD_GOOGLE, CARD_APPLE_PAY, CARD_ALIPAY, CARD_GRABPAY, CARD_PAYNOW, CARD_CASH, CARD_CHEQUE, CARD_NETS, CARD_BANK_TRANSFER } from '../common/images-s3';
import { getAppFlow } from '../views/utils/app.utils';
import * as Sentry from "@sentry/react";
const appFlow = getAppFlow();

// MAX NO OF YEARS FOR FIDYAH -  ILLNESS OR OLD AGE
export const MAX_NO_OF_YR = 100;

export function encryptData(data) {
    const encryptedData = CryptoJS.AES.encrypt(data, CRYPTO_ACCESS_KEY).toString();
    return encryptedData;
}

export function decryptData(data) {
    const decryptedData = CryptoJS.AES.decrypt(data, CRYPTO_ACCESS_KEY).toString(CryptoJS.enc.Utf8);
    return decryptedData;
}

AWS.config.update({
    region: AWS_REGION,
    accessKeyId: decryptData(AWS_SECRET_KEY_ID),
    secretAccessKey: decryptData(AWS_SECRET_ACCESS_KEY),
});

export async function getLoginPool() {

    let poolId = await getSecret(`/${config.TYPE.toLowerCase()}${paths.AuthorizerAccessKey}`).then(res => decryptData(res));
    let clientId = await getSecret(`/${config.TYPE.toLowerCase()}${paths.AuthorizerClientId}`).then(res => decryptData(res));

    const Pool = new CognitoUserPool({
        UserPoolId: poolId,
        ClientId: clientId
    });

    return Pool;
};

const ssm = new AWS.SSM();

export const getSecret = async (name) => {
    const res = await ssm
        .getParameter({
            Name: name,
            WithDecryption: false
        })
        .promise();
    return res.Parameter.Value;
}

export const COMPANY_NAME_FULL = 'Zakat Singapore';
export const WAKAF_COMPANY_NAME_FULL = 'Wakaf';
export const COMPANY_NAME_SHORT = '';
export const COMPANY_MICRO_SITE = 'https://www.zakat.sg/';
export const COMPANY_MICRO_SITE_FIDYAH = 'https://fidyah.zakat.sg/';
export const COMPANY_MICRO_SITE_WAKAF = "https://www.wakaf.sg/";
export const CURRENCY_SYMBOL = '$';
export const USER_NAME_AWS_COGNITO = 'bXVpcw==';
export const PASSWORD_AWS_COGNITO = 'QWRtaW5AMTIz';
// export const EMAIL_AWS_COGNITO = 'mayank.kumar@ideaqu.com'; //DEV Email
export const EMAIL_AWS_COGNITO = 'muis@givepls.com'; // UAT email

export const SCROLL_NAVIGATION = { 'ElementNavLink': null, 'Referrer': '' };

export const ENROL_FIELDS_MAX_CHAR_ONBEHALF = (appFlow === APP_FLOW.ZAKAT || appFlow === APP_FLOW.FIDYAH) ?  500 : 75;

export const CREDIT_CARD = {
    monthOptions: [
        { "value": "01", "label": "01" },
        { "value": "02", "label": "02" },
        { "value": "03", "label": "03" },
        { "value": "04", "label": "04" },
        { "value": "05", "label": "05" },
        { "value": "06", "label": "06" },
        { "value": "07", "label": "07" },
        { "value": "08", "label": "08" },
        { "value": "09", "label": "09" },
        { "value": "10", "label": "10" },
        { "value": "11", "label": "11" },
        { "value": "12", "label": "12" }
    ],

    cardImagesLocal: {
        AmericanExpress: '/images/cards/american-express-195x125.png',
        DefaultCard: '/images/cards/default-195x125.png',
        DinersClub: '/images/cards/diners-club-195x125.png',
        JCB: '/images/cards/jcb-195x125.png',
        MasterCard: '/images/cards/master-card-195x125.png',
        UnionPay: '/images/cards/union-pay-195x125.png',
        Visa: '/images/cards/visa-195x125.png',
    },

    cardImages: {
        AmericanExpress: CARD_AMERICAN,
        DefaultCard: CARD_DEFAULT,
        DinersClub: CARD_DINERS_CLUB,
        JCB: CARD_JCB,
        MasterCard: CARD_MASTER_CARD,
        UnionPay: CARD_UNION_PAY,
        Visa: CARD_VISA,
    },

    getCardExpiryYearList() {
        var yearList = [];
        var year = (new Date()).getFullYear();
        for (let i = 0; i < 21; i++) {
            const obj = {
                value: year + i,
                label: year + i
            }
            yearList.push(obj)
        }
        return yearList;
    },
}

export const PAYMENT_OPTIONS = {
    cardImagesLocal: {
        /* googlepay: '/images/cards/googlepay.svg',
        applepay: '/images/cards/applepay.svg',        
        alipay: '/images/cards/alipay.svg',
        grabpay: '/images/cards/grab-pay.svg', */
        googlepay: '/images/cards/googlepay.png',
        applepay: '/images/cards/applepay.png',
        alipay: '/images/cards/alipay.png',
        grabpay: '/images/cards/grab-pay.png',
        paynow: '/images/cards/pay-now.png',
        cash: '/images/cards/cash-195x125.png',
        cheque: '/images/cards/cheque-195x125.png',
        nets: '/images/cards/nets-195x125.png',
        banktransfer: '/images/cards/bank-transfer.png',
        default: '/images/cards/default-195x125.png',
    },

    cardImages: {
        googlepay: CARD_GOOGLE,
        applepay: CARD_APPLE_PAY,
        alipay: CARD_ALIPAY,
        grabpay: CARD_GRABPAY,
        paynow: CARD_PAYNOW,
        cash: CARD_CASH,
        cheque: CARD_CHEQUE,
        nets: CARD_NETS,
        banktransfer: CARD_BANK_TRANSFER,
        default: CARD_DEFAULT,
    }
}

export const GET_PARENT = (e, nodename, classname) => {
    let ele = e;
    try {
        do {
            if (nodename && ele.nodeName === nodename || classname && ele.classList.contains(classname)) {
                return ele;
            } else {
                ele = ele.parentNode;
            }
        } while (ele.parentNode)
    } catch (ex) {
        //throw ex;
    }
}

export const TEXT_TRIM = (text, characters) => {
    try {
        if (text.length > characters) {
            return ((text.substr(0, characters)).trim() + '...');
        } else {
            return text;
        }
    } catch (ex) {
        return text;
    }
}

export const commaSeperatedAmount = (sign, value) => {
    if (value === undefined || value === null)
        return ''
    let val = value.toString();
    let str = [];
    let decimalval = val.split('.')
    console.log(decimalval, 'decimalval')

    if (decimalval.length === 2) {
        val = decimalval[0];
    }

    if (val && val.length > 3) {
        for (let ind = val.length - 1; ind >= 0; ind--) {
            if (!(ind % 3) && ind !== 0) {
                str.push(val[val.length - 1 - ind]);
                str.push(',');
            } else {
                str.push(val[val.length - 1 - ind]);
            }
        }
        val = str.join('');
    }

    if (decimalval.length === 2) {
        console.log(decimalval[1], 'decimalval[1]',sign + val + '.' + decimalval[1] )
        return sign + val + '.' + decimalval[1];
    } else {
        return sign + val;
    }
}

/** used for react-select control */
export let selectedStyles = {
    option: (provided, state) => {
        return {
            ...provided,
            color: state.isSelected ? '#008462' : state.isDisabled ? '#ccc' : '',
            backgroundColor: state.isSelected ? 'transparent' : 'white',
            cursor: state.isFocused ? 'pointer' : 'default',
            '&:hover': { backgroundColor: state.data?.disabled ? '' : '#00846220', color: state.isDisabled ? '' : '#192931' }
        }
    },
}

export const setNavActiveInactive = (exception) => {
    let children = SCROLL_NAVIGATION.ElementNavLink ? SCROLL_NAVIGATION.ElementNavLink.childNodes : null;
    if (children) {
        children.forEach(item => {
            if (!exception) {
                item.classList.remove('active');
            } else {
                if (item.innerText.trim().toUpperCase() === exception.replace('-', ' ').toUpperCase()) {
                    item.classList.add('active');
                } else {
                    item.classList.remove('active');
                }
            }
        });
    }
}

export const scrollTo = (param, top) => {
    let offset = true;
    let ele = document.getElementById(param);
    if (ele) {
        if (document.body.offsetWidth <= 1024) { offset = false; }
        document.body.scrollTop = param.toUpperCase() === 'HOME' ? 0 : (typeof top === 'number') ? top : (ele.offsetTop - (offset ? SCROLL_NAVIGATION.ElementNavLink.offsetHeight : 100));
        setNavActiveInactive(param.toUpperCase());

    } else if (typeof param === 'number') {
        document.body.scrollTop = param;
    } else {
        document.body.scrollTop = 0;
        if (param) {
            setNavActiveInactive(param);
        } else {
            setNavActiveInactive();
        }
    }
    SCROLL_NAVIGATION.Referrer = '';
}


export function getCharityIdFromPathname() {
    const pathname = window.location.pathname.toLowerCase(); 
    const origin = window.location.origin.toLowerCase();
  
    let matchingConfig = charityConfig.find(config => {
      const urlPath = new URL(config.url).pathname.toLowerCase();
      if(urlPath === '/')
        {
            return null
        }
      return pathname === urlPath || pathname.startsWith(`${urlPath}/`);
    });

    if(!matchingConfig) {
        if(origin.includes(config.ROUTES.WAKAF)) {
            matchingConfig = charityConfig.find(key => key.url.toLowerCase().includes(config.ROUTES.ILMU));
        }
    }
  
    // Return charityId if a matching configuration is found, otherwise return null
    return matchingConfig ? matchingConfig : null;
  }

export function getPaymentEndpoint() {
    switch (getAppFlow()) {
        case APP_FLOW.ILMU:
        case APP_FLOW.WMS:
        case APP_FLOW.PLEDGE:
            return 'v8';
        default:
            return 'v8';
            // return 'v8'; Changing to v6 for dev-zakat testing purpose once done will revert this to v8
    }
}

export const captureApiError = (error) => {
    if (!error || typeof error !== 'object' || Object.keys(error).length === 0) {
        return;
    }
    const hostname = window.location.hostname;
  
    Sentry.captureEvent({
      message: `[${hostname}] API Error: ${error.message || 'Unknown error'}`,
      exception: {
        values: [
          {
            type: error.name || 'Error',
            value: error.message || 'An unknown error occurred',
          },
        ],
      },
      level: 'error', // to error severity
    });
};
